const rCamelCase = /([a-z0-9])([A-Z])/g;

export const capitalizeFirstLetter = (field: string): string => {
  return field.charAt(0).toUpperCase() + field.slice(1);
};

export const camelToWord = (field: string): string => {
  return field.replace(rCamelCase, '$1 $2').toLowerCase();
};

export const customValidationString = (validationString: string): string => {
  return validationString?.substring(
    validationString.lastIndexOf('[') + 1,
    validationString.lastIndexOf(']')
  );
};

export const getEntityTypeData = (prefix: string) => {
  const entityType = prefix.replace('.', '');
  return {
    entityType,
    isNestedEntity: prefix.includes('.'),
  };
};

export const getFieldName = (prefix: string, field: string) => {
  const {entityType, isNestedEntity} = getEntityTypeData(prefix);
  return isNestedEntity ? `${entityType}.${field}` : field;
};

export const getError = (prefix: string, field: string, errorList: any) => {
  const {entityType, isNestedEntity} = getEntityTypeData(prefix);
  return isNestedEntity ? errorList[entityType]?.[field] : errorList[field];
};

export const getField = (prefix: string, field: string, errorList: any) => {
  return {
    name: getFieldName(prefix, field),
    error: getError(prefix, field, errorList),
  };
};
